var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEthLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.62478 0.209778V4.6457L8.37406 6.32105L4.62478 0.209778Z",
    fill: "white",
    fillOpacity: 0.602
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62478 0.209778L0.875 6.32105L4.62478 4.6457V0.209778Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62478 9.19565V12.2098L8.37656 7.0192L4.62478 9.19565Z",
    fill: "white",
    fillOpacity: 0.602
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62478 12.2098V9.19515L0.875 7.0192L4.62478 12.2098Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62478 8.498L8.37406 6.32105L4.62478 4.6467V8.498Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.875 6.32105L4.62478 8.498V4.6467L0.875 6.32105Z",
    fill: "white",
    fillOpacity: 0.602
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEthLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eth-light.85bdeeba12d1f1da3de235f6aa1670f0.svg";